<template>
 <span
   role="button"
   aria-label="Open the upgrade offer"
   class="upgrade-label__container"
   @click.stop="openPopup"
 >
    <span
      class="upgrade-label__background"
      :class="{'overshadow':overshadow}"
    />
    <button
      class="upgrade-label__button"
      :class="{'center-position-x':centerPositionX,'center-position-y':centerPositionY}"
      :style="buttonCoords"
    />
   <button
     class="upgrade-label__button-mobile"
     :class="{'center-position-x':centerPositionX,'center-position-y':centerPositionY}"
     :style="buttonCoords"
   />
 </span>
</template>

<script>
import { mapMutations } from 'vuex';

function parseCordsToPosition(cords) {
  const parsedCords = Object.entries(cords).map(([position, value]) => {
    const parsedValue = typeof value === 'number' ? `${value}px` : value;

    return `${position}: ${parsedValue};`;
  });

  return parsedCords.join('');
}

export default {
  name: 'UpgradeLabel',
  props: {
    coords: {
      type: Object,
      required: true,
    },
    overshadow: {
      type: Boolean,
    },
    premium: {
      type: Boolean,
      default: false,
    },
    centerPositionX: {
      type: Boolean,
      default: false,
    },
    centerPositionY: {
      type: Boolean,
      default: false,
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openPopup() {
      if (this.disableClick) return null;

      return this.premium ? this.openProToPremiumPopup : this.openFreeToProPopup;
    },
    buttonCoords() {
      return parseCordsToPosition(this.coords);
    },
  },
  methods: {
    ...mapMutations({
      openFreeToProPopup: 'openFreeToProPopup',
      openProToPremiumPopup: 'openProToPremiumPopup',
    }),
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";

.upgrade-label {
  &__container {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    z-index: 1;

    cursor: pointer;
  }

  &__background {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    &.overshadow {
      opacity: 0.3;
      background-color: var(--muted);
    }
  }

  &__button {
    position: absolute;
    z-index: 2;
    border-radius: 3px;
    width: 65px;
    height: 20px;
    background-image: url("~@/assets/icons/optimized/upgrade_desktop.svg");

    @include media-sm-only() {
      display: none;
    }

    &.center-position-x {
      left: 50%;
      transform: translate(-50%);
    }

    &.center-position-y {
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  &__button-mobile {
    position: absolute;
    z-index: 2;
    border-radius: 3px;
    width: 18px;
    height: 18px;
    background-image: url("~@/assets/icons/optimized/upgrade_mobile.svg");

    @include media-lg() {
      display: none;
    }

    &.center-position-x {
      left: 50%;
      transform: translate(-50%);
    }

    &.center-position-y {
      top: 50%;
      transform: translate(0, -50%);
    }
  }
}
</style>
